const joinLabel = (code?: string, name?: string): string =>
  [...new Set([code?.trim(), name?.trim()].filter(Boolean))].join(' · ');

export function branchDisplayLabel(branch?: {
  code?: string;
  short?: string;
  name?: string;
}): string {
  return (
    joinLabel(branch?.code, branch?.short || branch?.name) || 'ไม่พบข้อมูลสาขา'
  );
}

export function deviceDisplayLabel(device?: {
  deviceCode?: string;
  label?: string;
}): string {
  return joinLabel(device?.deviceCode, device?.label) || 'ไม่พบข้อมูลเครื่อง';
}

/** Short references distinguish legacy machines without showing full UUIDs. */
export function missingDeviceLabels(
  ids: string[],
  label = 'เครื่องที่ไม่พบข้อมูล',
): Map<string, string> {
  const uniqueIds = [...new Set(ids)];
  return new Map(
    uniqueIds.map((id) => {
      let length = Math.min(8, id.length);
      while (
        length < id.length &&
        uniqueIds.some(
          (other) => other !== id && other.slice(-length) === id.slice(-length),
        )
      )
        length++;
      const reference = `${length < id.length ? '…' : ''}${id.slice(-length)}`;
      return [id, `${label} · ${reference}`];
    }),
  );
}
